import {useTheme} from 'styled-components';

import {isNotNil} from 'ramda';

import type {PhotoCheckerPhotoEvaluationSaleVehiclePhoto} from '@dms/api/vehicle';

import {PhotoCheckerSilhouetteSvg} from './PhotoCheckerSilhouetteSvg';
import type {PhotoCheckerSilhouetteVariantColors} from './types/PhotoCheckerSilhouetteVariantColors';
import {getPhotoCheckerPartVariants} from './utils/getPhotoCheckerPartVariants';

export interface PhotoCheckerSilhouetteProps {
  evals?: PhotoCheckerPhotoEvaluationSaleVehiclePhoto[];
}

export function PhotoCheckerSilhouette({evals}: PhotoCheckerSilhouetteProps) {
  const theme = useTheme();
  const hasEvaluation = isNotNil(evals);

  const colorsByVariant = {
    pass: {
      circle: theme.colors.palettes.green[50][100],
      gradient: theme.colors.palettes.green[50][100],
      fill: theme.colors.palettes.green[30][100],
    },
    caution: {
      circle: theme.colors.palettes.orange[60][100],
      gradient: theme.colors.palettes.orange[60][100],
      fill: theme.colors.palettes.orange[30][100],
    },
    fail: {
      circle: theme.colors.palettes.red[60][100],
      gradient: theme.colors.palettes.red[60][100],
      fill: theme.colors.palettes.red[30][100],
    },
    missing: {
      circle: theme.colors.palettes.neutral[100][100],
      gradient: theme.colors.palettes.neutral[100][100],
      fill: theme.colors.palettes.neutral[30][100],
    },
    plain: {
      circle: theme.colors.palettes.white[10][100],
      gradient: theme.colors.palettes.white[10][100],
      fill: theme.colors.palettes.white[10][100],
    },
  } satisfies PhotoCheckerSilhouetteVariantColors;

  const partVariants = getPhotoCheckerPartVariants(evals);

  return (
    <PhotoCheckerSilhouetteSvg
      colorsByVariant={colorsByVariant}
      hasEvaluation={hasEvaluation}
      partVariants={partVariants}
    />
  );
}
